import { Observable } from 'rxjs';
import { LocalizedData } from '../../common';
import { Content } from '../../domain';

export abstract class AbstractRecommendationService {
  public abstract getRecommendationTrayContent$(
    recommendationQuery: Record<string, string>
  ): Observable<{ preview: Content[]; titleLocalized: LocalizedData<string> }>;
  public abstract getRecommendedContentPreviews$(guid: string): Observable<Content[]>;
}
